document.querySelectorAll('.contact-list').forEach(($list) => {
  const image = $list.querySelector('.contact__image');

  if (image != null) {
    $list.classList.add('contact-list--mixed');
  }
});
